import { ReactNode } from 'react'
import clsx from 'clsx'

interface BaseContainerProps {
  children: ReactNode
  title?: string
  className?: string
  action?: ReactNode
}

const BaseContainer = ({
  children,
  title,
  className,
  action,
}: BaseContainerProps) => {
  return (
    <div className={clsx('rounded-[12px] bg-white px-6 py-5', className)}>
      {(!!title || !!action) && (
        <div className='mb-4 flex items-center justify-between'>
          <p className='text-2xl text-[#002652]'>{title}</p>
          {action}
        </div>
      )}
      {children}
    </div>
  )
}

export default BaseContainer
